var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"margin":"auto"},attrs:{"id":_vm.adId}})])}
var staticRenderFns = []

export { render, staticRenderFns }